import Vue from 'vue'
import 'es6-promise/auto'
import store from './store/index'

import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'

//Vue.config.productionTip = false

const token = localStorage.getItem('auth_token')
if (token) {
 // Vue.prototype.axios.defaults.headers.common['Bearer'] = token
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
